export const SolowaySiteIdAlias = {
    B2B: '224286',
    B2C: '224970',
} as const;

type SolowaySiteId = (typeof SolowaySiteIdAlias)[keyof typeof SolowaySiteIdAlias];

export interface SolowayPixelData {
    siteId: SolowaySiteId;
    eventId?: string;
}

export const sendSolowayConversion = ({ siteId, eventId }: SolowayPixelData): void => {
    const pixel = new Image();
    const eventParam = eventId ? `&sz=${eventId}` : '';
    pixel.src = `//ad.adriver.ru/cgi-bin/rle.cgi?sid=${siteId}&bt=21&pz=0&rnd=468545526${eventParam}`;
    pixel.referrerPolicy = 'no-referrer-when-downgrade';
    pixel.style.display = 'none';
    document.body.appendChild(pixel);
};
